export default __webpack_public_path__ + "static/media/dev.e2c5fddd.svg";